import { render, staticRenderFns } from "./SelectTicketCategory.vue?vue&type=template&id=094aaffe"
import script from "./SelectTicketCategory.vue?vue&type=script&lang=js"
export * from "./SelectTicketCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports